import _ from 'lodash'

export default function appVersion(versionString = '') {
  const parse = (version = versionString) => {
    const splitedVersion = _.split(version, '.')
    return _.map(
      // '1.0.0' -> ['1', '0', '0']
      // '1.12' -> ['1', '12', '0']
      _.times(3, (index) => (
        splitedVersion[index] || '0'
      )),
      _.toNumber,
    )
  }
  const isBefore = (version = '') => {
    const zipped = [
      parse(),
      parse(version),
    ]
    let result = null
    _.forEach(_.unzip(zipped), (pair) => {
      // skip
      if (_.get(pair, '0') === _.get(pair, '1')) return
      // exit
      if (_.isBoolean(result)) return false
      result = _.get(pair, '0') < _.get(pair, '1')
    })
    return result || false
  }
  const isAfter = (version = '') => {
    const zipped = [
      parse(),
      parse(version),
    ]
    let result = null
    _.forEach(_.unzip(zipped), (pair) => {
      // skip
      if (_.get(pair, '0') === _.get(pair, '1')) return
      // exit
      if (_.isBoolean(result)) return false
      result = _.get(pair, '0') > _.get(pair, '1')
    })
    return result || false
  }
  return {
    parse,
    isBefore,
    isAfter,
    isEqual: (version = '') => (
      !isBefore(version)
      && !isAfter(version)
    ),
  }
}
